import { render, staticRenderFns } from "./afterSalesInboundScan.vue?vue&type=template&id=5054bb94&scoped=true"
import script from "./afterSalesInboundScan.vue?vue&type=script&lang=js"
export * from "./afterSalesInboundScan.vue?vue&type=script&lang=js"
import style0 from "./afterSalesInboundScan.vue?vue&type=style&index=0&id=5054bb94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054bb94",
  null
  
)

export default component.exports